// extracted by mini-css-extract-plugin
export default {"contactUsContainer":"ContactUs_contactUsContainer__tTXxF","contactUsTitle":"ContactUs_contactUsTitle__tjDSd"};